module.exports = __webpack_public_path__ + "img/freesound_trigger.3fd010a7.jpg";